export const INTRO = "intro";
export const BASIC_DETAILS = "basicDetails";
export const FILE_UPLOAD = "upload";
export const FILE_DETAILS = "details";
export const TERMS = "terms";

export const list = [INTRO, BASIC_DETAILS, FILE_UPLOAD, FILE_DETAILS, TERMS];
export const labels = [
  "step_bar_basic_details_label",
  "step_bar_file_upload_label",
  "step_bar_file_details_label",
  "step_bar_terms_label",
];
